<template lang="pug">
  b-overlay(:show='hasFooterMenu' variant='dark' v-if='currentHeadline')
    .row.new-banner.align-items-center.px-2
      
      // Image
      .col-1.p-0
        transition(name="custom-classes-transition" enter-active-class='animated slideInLeft faster' leave-active-class='animated slideOutLeft faster' mode="out-in" appear)
          img.img-fluid.d-block.mx-auto.p-1.new-banner-image(:src="isFanFestActive ? currentOffer.image : currentOffer.image" :key="index" :class="[isFanFestActive ? 'visible' : 'visible']")
      
      // Offer
      #offer.col.p-0.h-100.text-white(style="overflow:hidden;")
        transition(:name="transitionForHeadline.name" :enter-active-class='transitionForHeadline.enter' :leave-active-class='transitionForHeadline.exit' mode="out-in" appear)
          a.text-decoration-none.text-white.d-flex.align-items-center.justify-content-left.h-100.px-3(:key='currentHeadline' :href='currentOffer.url' target='_blank') {{ isFanFestActive ? currentHeadline : currentHeadline }}
      
      // Buttons
      .col-2.p-0(v-if='hasCTA === false')
        .d-flex.justify-content-end
          // Mute
          b-button.bg-gray.border-0.text-white.text-uppercase.font-weight-bold.mx-2(v-if="shouldMute" @click='mute')
            i.fa.fa-x.text-light(style="font-size: 2.5vh" :class="[shouldMute ? 'fa-volume-mute' : 'fa-volume-up']")
          // Live
          FanFestViewService(:screenName="screenName" :shouldMute="shouldMute" :videoList="fanfestViews" :canStream="fanfestStreamingEnabled" @fanfest-members="notifyFanFestMembersChanged")
          //b-button.bg-danger.border-0.text-white.text-uppercase.font-weight-bold.mx-2(@click='goFanfest')
            i.fa.fa-video-camera.fa-2x.text-light    
       
      
      //CTA
      .col-3.p-0.h-100(v-if='hasCTA === true')
        transition(name="custom-classes-transition" enter-active-class='animated slideInRight faster' leave-active-class='animated slideOutRight faster' mode="out-in" appear)
          a#cta.d-flex.align-items-center.justify-content-left.text-white.text-uppercase.text-decoration-none.h-100.px-3(:key='index' :class="[isFanFestActive ? 'visible' : 'visible']" :href='currentOffer.url' target='_blank') {{ isFanFestActive ? currentOffer.footer :currentOffer.footer }}

      //Image
      .col-1.p-0(v-if='hasCTA === false')
        img.img-fluid.d-block.mx-auto.p-1.new-banner-image(src='https://vici-resources.s3.amazonaws.com/other/vici_logo_round_lowrez.png' :key="index" :class="[isFanFestActive ? 'visible' : 'visible']")
    template(v-slot:overlay)
      .container-float.h-100
        #menuBanner(ref='menuVOD')
          button.btn.btn-outline-light.mx-auto.text-uppercase.font-weight-bold.align-self-center(type='button' @click="hasFooterMenu = false") Update Offers
          // button.btn.btn-outline-danger.mx-auto.text-uppercase.font-weight-bold.align-self-end(type='button' @click='hasVODMenu = false') Back    
</template>

<script>
import axios from "axios";
import FanFestViewService from "../components/services/FanFestService.vue";

const transitionsForHeadline = [
  {
    name: "custom-classes-transition",
    enter: "animated slideInLeft faster",
    exit: "animated slideOutLeft faster"
  },
  {
    name: "headline-scroll",
    enter: "animated slideInUp faster",
    exit: "animated slideOutDown faster"
  }
];

const headlineDuration = 7500;

export default {
  name: "Footer",
  data() {
    return {
      offers: [],
      index: -1,
      currentOffer: undefined,
      currentHeadline: undefined,
      transitionForHeadline: transitionsForHeadline[0],
      headlineTimer: undefined,
      hasFooterMenu: false,
      hasCTA: false,
      /* fanfestOffer: {
        image:'https://vici-resources.s3.amazonaws.com/psg-logo-tous-unis.jpg',
        topic:'Live stream between Mbappe and two fans',
        headline:'Diffusion en direct entre Mbappe et deux fans',
        footer:'Enter Raffle',
      } */
    };
  },
  components: {
    FanFestViewService
  },
  props: {
    isFanFestActive: Boolean,
    shouldMute: Boolean,
    screenName: String,
    fanfestStreamingEnabled: Boolean,
    fanfestViews: Array
  },
  watch: {
    isFanFestActive: function() {
      /* const self = this;
      setTimeout(() => {
        self.updateOffer();        
      }, 500); */
    }
  },
  methods: {
    configOffers: function() {
      var organizerID = this.$route.params.organizer;
      axios
        .get(`${process.env.VUE_APP_CONFIG_ROOT}/${organizerID}/offers`)
        .then(response => {
          // console.log(`${response.data.length} offers loaded`)
          this.offers = response.data;
          this.currentOffer = response.data[0];

          this.updateOffer();
        })
        .catch(err => Promise.reject(err.message));
    },
    updateHeadline: function() {
      if (this.offers.length === 0) return;

      var possibleHeadlines = this.currentOffer.headline.split(", ");
      possibleHeadlines.unshift(this.currentOffer.topic);

      if (this.currentHeadline)
        this.transitionForHeadline = transitionsForHeadline[1];

      for (var i = 0; i < possibleHeadlines.length; i++) {
        if (possibleHeadlines[i] == this.currentHeadline) {
          if (i == possibleHeadlines.length-1) {
            this.currentHeadline = possibleHeadlines[0];
            break;
          }
          else {
            this.currentHeadline = possibleHeadlines[i+1];
            break;
          }
        }
      }

      if (!this.currentHeadline)
        this.currentHeadline = possibleHeadlines[0];

      if (possibleHeadlines.length > 1) {
        const self = this;
        self.headlineTimer = setTimeout(function() {
          self.updateHeadline();
        }, headlineDuration);
      }

      return possibleHeadlines.length;
    },
    updateOffer: function() {
      if (this.$props.isFanFestActive && this.fanfestOffer) {
        this.currentOffer = this.fanfestOffer;
        this.currentHeadline = this.currentOffer.headline;
        return;
      } 

      if (this.offers.length === 0) return; // skip if nil
      if (this.currentHeadline && this.offers.length === 1 && this.offers[0].topic === this.currentOffer.topic) return; // skip if there's only 1 offer

      this.transitionForHeadline = transitionsForHeadline[0];
      this.currentHeadline = undefined;
      clearInterval(this.headlineTimer);

      this.index = this.index + 1 >= this.offers.length ? 0 : this.index + 1;
      this.currentOffer = this.offers[this.index];
      var numHeadlines = this.updateHeadline();

      const self = this;
      setTimeout(() => {
        self.updateOffer();
      }, headlineDuration * numHeadlines);
    },
    mute: function() {
      this.$emit('mute')
    },
    notifyFanFestMembersChanged: function(numMembers) {
      this.$emit('fanfest-members', numMembers)
    }
  },
  created: function() {
    this.configOffers();
  }
};
</script>

<style>
.banner-fixed {
  position: absolute;
  left: 5%;
  right: 5%;
  bottom: 5%;
}

.banner-text-sm {
  font-size: 1.5vw;
  font-weight: 800;
}

.banner-text-lg {
  font-size: 2vw;
  font-weight: 800;
}

.banner-image {
  width: 75%;
}

.topic {
  background-color: #9e00ff;
}

.topic-live {
  background-color: red;
}

#cta {
  background-color: #7900c9;
}

#cta:hover {
  background-color: #a51cff;
}

#offer:hover {
  background-color:#424242;
}

.new-banner {
  height: 6vw;
  font-size: 1.8vw;
  font-weight: 700;
  background-color: #191919;
  overflow: hidden;
}


.new-banner-image {
  height: 6vw;
  background-color: black;
  padding: 5%;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-1000px);
  opacity: 0;
}
</style>